import { FaBuilding } from "react-icons/fa";

const Sponsor = ({ sponsors = [] }) => {
  return (
    // <div className="col-12 col-md-4 mb-4">
      <div className="rounded border shadow-sm bg-dark text-light border-primary">
        <div className="p-4">
          <h5 className="text-light fw-bold mb-3">Sponsors</h5>

          <div className="row text-center">
            {sponsors.length > 0 ? (
              sponsors.map((sponsor, idx) => (
                <div key={idx} className="col-6 col-md-3 mb-3">
                  <div className="bg-secondary rounded p-3 h-100 d-flex flex-column align-items-center justify-content-center hover-card">
                    {sponsor.logo ? (
                      <img
                        src={sponsor.logo}
                        alt={sponsor.name}
                        className="img-fluid mb-2"
                        style={{ maxHeight: "60px", objectFit: "contain" }}
                      />
                    ) : (
                      <FaBuilding size={40} className="mb-2 text-light" />
                    )}
                    <small className="text-light">{sponsor.name}</small>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-muted">No sponsors added yet</p>
            )}
          </div>
        </div>
      </div>
    // </div>
  );
};

export default Sponsor;